export default "__VITE_ASSET__d8ab2b4f__"